import React from "react";
import { Helmet } from "react-helmet";
import CtaSection from "../Components/internal-pages/Cta_Section";
import LeftImgrightContent from "../Components/internal-pages/Leftimg_rightContent";
import RightimgLeftContent from "../Components/internal-pages/Rightimg_leftContent";
import NogapRightImage from "../Components/internal-pages/No_gap_right_Img";
import ClinetsLogoSlider from "../Components/home/ClientsLogoSlider";
import Whychooseus from "../Components/internal-pages/WhyChooseus";

const EcofriendlyGifts = ()=>{
    const CTAContent = [
        {
          pageName: "Eco-Friendly Gifts",
          paragraphitalic: "Thoughtful Gifts for a Sustainable Future ",
          paragraphText:
            "eYantra believes that gifting can be both meaningful and responsible. Our Eco-Friendly Gifts are designed to reflect your commitment to sustainability while still delivering an impactful and memorable experience. Whether you're looking to impress clients, reward employees, or celebrate a special occasion, our eco-conscious options makes sure you make a positive difference.",
          ContactFormName: "Eco-friendly-gifts",
        },
      ];
    
      const ContentImg = [
        {
          index: 0,
          leftImg: "./assests/images/banners/Eco-Friendly Gifts for Corporate Gifting Banner.png",
          leftHeading: "Eco-Friendly Gifts for Corporate Gifting ",
          leftSmallpara: "Sustainability with Style",
          leftParagraph:
            "Corporate gifting doesn’t have to come at the expense of the planet. With our eco-friendly corporate gifts, you can show your commitment to the environment while strengthening your brand’s reputation. From biodegradable products to reusable items, our curated collection will leave a mark – without the environmental cost.",
          leftRedirectUrl: "/eco-friendly-gifts/eco-friendly-gifts-for-corporate-gifting",
        },
        {
          index: 1,
          leftImg: "./assests/images/banners/Eco-Friendly Gifts for Clients and Events Banner.png",
          leftHeading: "Eco-Friendly Gifts for Clients and Events ",
          leftSmallpara: "Eco-Chic and Event-Ready ",
          leftParagraph:
            "Stand out in your next event or client meeting with eco-friendly gifts that reflect your brand’s green commitment. From corporate events to client appreciation gifts, our environmentally conscious options make sure your impact is both memorable and responsible.",
          leftRedirectUrl: "/eco-friendly-gifts/eco-friendly-gifts-for-clients-and-events",
        },
      ];
      const rightImgContent = [
        {
          index: 0,
          rightImg: "./assests/images/banners/Eco-Friendly Gifts for Employees  Banner.png",
          rightHeading: "Eco-Friendly Gifts for Employees ",
          rightSmallpara: "Gifts that Give Back to the Earth ",
          rightParagraph:
            "Show your employees how much you value their contribution and your shared commitment to sustainability. Our range of eco-friendly gifts for employees includes everything from plant-based products to reusable gadgets – perfect for fostering a green work culture.",
          rightRedirectUrl: "/eco-friendly-gifts/eco-friendly-gifts-for-employees",
        },
      ];
    
      const NoGapContent = [
        {
          NogaprightImg: "./assests/images/banners/Eco-Friendly Gifts for All Occasions Banner.png",
          NogaprightHeading: "Eco-Friendly Gifts for All Occasions",
          NogaprightSmallpara: "Gift Green, Live Green ",
          NogaprightParagraph: "Whether it’s a festival, a birthday, or a special celebration, our eco-friendly gift solutions cater to every occasion. Show your care for both the employee and the planet with sustainable, personalized gifts that make an impact. ",
          NogaprightRedirectUrl: "/eco-friendly-gifts/eco-friendly-gifts-for-all-occasions",
        },
      ];
    
    return(
        <>
        <Helmet>
            <title>eYantra Corporate Gifts in Hyderabad</title>
            <meta name="description" content="eYantra delivers corporate gifting, joining kits, employee rewards, and company merchandise with onboarding and welcome kits across Hyderabad."/>
            <meta name="keywords" content="eyantra, corporate gifting, joining kits, rewards and recognitions, onboarding kits for employees, corporate gifts for employees, welcome kits, company merchandise, corporate gifts in hyderabad"/>
        </Helmet>

        <div className="p-0 m-2">
        <CtaSection data={CTAContent} />

        <LeftImgrightContent leftImgContent={ContentImg[0]} />
        <RightimgLeftContent data={rightImgContent[0]} />
        <LeftImgrightContent leftImgContent={ContentImg[1]} />

        <NogapRightImage data={NoGapContent[0]} />
        </div>
        <div className="my-5">
            <ClinetsLogoSlider/>
        </div>
        <Whychooseus/>
     
          
        </>
    )
}

export default EcofriendlyGifts;